export default "__VITE_ASSET__53afdb78__"